import defaults from './defaults';

export default class {
  constructor({ articleSummaries }) {
    this.articleSummaries = articleSummaries;
  }

  get itemListElement() {
    return this.articleSummaries.map((article, index) => ({
      '@type': 'ListItem',
      position: index,
      url: `https://www.autolist.com/${article.parent_page.slug}/${article.slug}`,
    }));
  }

  toJSON() {
    const data = {
      '@type': 'ItemList',
      itemListElement: this.itemListElement,
    };

    return { ...defaults, ...data };
  }
}
